import { createStyles, makeStyles } from '@material-ui/core';

const baseLayoutStyles = makeStyles((theme) =>
    createStyles({
        root: {
            width: '100%',

            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            position: 'relative'
        },
        rootMinHeight: {
            minHeight: '100vh'
        },
        darkBackground: {
            backgroundColor: theme.palette.grey['600']
        },
        blackBackground: {
            backgroundColor: '#000'
        },
        sideBackground: {
            backgroundColor: theme.palette.grey['400']
        },
        monoliteBackground: {
            backgroundColor: theme.palette.grey['500']
        },
        lightBackground: {
            backgroundColor: '#FFF'
        },
        mainContainer: { paddingTop: theme.mixins.toolbar.minHeight }
    })
);
export default baseLayoutStyles;
